import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Phone = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Phone_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.775 10.56-.72.718a.907.907 0 0 1-.637.268.822.822 0 0 1-.364-.084 9.8 9.8 0 0 1-4.516-4.515.882.882 0 0 1 .184-1.002l.72-.72c.5-.5.78-1.178.78-1.885V1.778C6.222.796 5.426 0 4.445 0H2.667A2.66 2.66 0 0 0 .782.782 2.66 2.66 0 0 0 0 2.666C0 10.036 5.964 16 13.334 16c1.44-.009 2.666-1.226 2.666-2.666v-1.779c0-.981-.796-1.777-1.778-1.777h-1.561c-.708 0-1.386.28-1.886.781ZM3.64 7.385a10.8 10.8 0 0 0 4.973 4.974c.26.127.535.186.805.186.501 0 .987-.203 1.344-.56l.72-.72a1.663 1.663 0 0 1 1.179-.488h1.561c.43 0 .778.348.778.777v1.779c0 .88-.773 1.659-1.67 1.666m0 0C6.515 14.998 1 9.482 1 2.666c0-.458.187-.874.49-1.176A1.66 1.66 0 0 1 2.667 1h1.778c.43 0 .777.348.777.778V3.34c0 .442-.175.866-.488 1.178l-.719.72c-.538.538-.741 1.397-.375 2.148"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Phone_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Phone;